import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApiInterceptor } from './api.interceptor';
import { TokenInterceptor } from './token/token.interceptor';


@NgModule({
  declarations: [],
  imports: [],
  providers: [
    // HTTPインターセプター
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true},
  ]
})
export class ApiModule { }
